import { render } from "./JobItem.vue?vue&type=template&id=2d4fb06e"
import script from "./JobItem.ts?vue&type=script&lang=js"
export * from "./JobItem.ts?vue&type=script&lang=js"

import "./JobItem.vue?vue&type=style&index=0&id=2d4fb06e&lang=css"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__